import { LoadingOutlined, UserOutlined } from "@ant-design/icons";
import { Avatar, Form, Tooltip, Upload } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getS3Media, updateUserFormsDetails } from "../../services/awsServices";
import { setProfilePictureUrl } from "../../slices/modalSlice";
import { getUserAllFormsDetails } from "../../slices/userSlice";
import { SIGNUP_FORM_BASIC } from "../../utils/constant";
import dayjs from "../../utils/myDayjs";
import toastMessage from "../../utils/toastMessage";
import { uploadDocFun } from "../../utils/utils";
import GradientButton from "../Button/GradientButton";
import CurrentInput from "../CurrentInput/CurrentInput";
import FormItem from "../Interactions/FormItem";
import LoadingCom from "../LoadingCom";

const format = import.meta.env.VITE_APP_DATE_FORMAT || "YYYY-MM-DD";

const BasicInformationStep = () => {
  const formGenerationInfo = SIGNUP_FORM_BASIC["Basic Information"];
  const [isFileUploading, setIsFileUploading] = useState(false);

  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const userAttributes = useSelector((state) => state.user.userAttributes);
  const userAllFormsDetails = useSelector(
    (state) => state.user.userAllFormsDetails
  );
  const [userData, setUserData] = useState({
    Email: userAttributes?.email,
    Phone: userAttributes?.phone_number,
  });
  const [imageData, setImageData] = useState({
    passport: [],
    resume: [],
    profile: { preview: false, fileList: [] },
  });
  const [loading, setLoading] = useState(false);
  console.log("🚀 ~ BasicInformationStep ~ loading:", loading);
  const [dpLoading, setDpLoading] = useState(false);
  const basicInfoData = userAllFormsDetails.find(
    (data) => data.SK === "Profile#BasicInfo"
  );
  const btnDisableCond =
    basicInfoData?.IsFinalSubmit && basicInfoData?.IsFinalSubmit;
  console.log("🚀 ~ useEffect ~ basicInfoData:", basicInfoData);
  console.log("🚀 ~ BasicInformationStep ~ imageData:", imageData);
  useEffect(() => {
    if (basicInfoData) {
      // setUserData(basicInfoData);
      if (basicInfoData?.Documents?.ProfilePicture) {
        setDpLoading(true);
        getS3Media(basicInfoData.Documents.ProfilePicture)
          .then((res) => {
            setImageData((prev) => ({
              ...prev,
              profile: {
                ...prev.profile,
                preview: res?.data.url,
              },
            }));
            dispatch(setProfilePictureUrl(res?.data.url));
            setDpLoading(false);
          })
          .catch((err) => {
            setDpLoading(false);
          });
      }
      // console.log(typeof basicInfoData.DOB , " ==basicInfoData.DOB:", basicInfoData.DOB);
      // getS3Media(basicInfoData.Documents.Passports).then((res) => {
      //   setImageData((prev) => ({
      //     ...prev,
      //     passport: res?.data.url,
      //   }));
      // });
      // getS3Media(basicInfoData.Documents.Resume).then((res) => {
      //   setImageData((prev) => ({
      //     ...prev,
      //     resume: res?.data.url,
      //   }));
      // });
      let dataForCheckbox = [];
      if (basicInfoData?.IsWorking) dataForCheckbox.push("working");
      if (basicInfoData?.IsStudent) dataForCheckbox.push("studying");
      // console.log(dataForCheckbox, " ==dataForCheckbox");
      setUserData(() => ({
        ...basicInfoData,
        ...basicInfoData.Documents,
        Working: dataForCheckbox,
        DOB: basicInfoData.DOB ? dayjs(basicInfoData.DOB, format) : null,
      }));
      form.setFieldsValue({
        ...basicInfoData,
        Working: dataForCheckbox,
        DOB: basicInfoData.DOB ? dayjs(basicInfoData.DOB, format) : null,
      });
    }
  }, [userAllFormsDetails]);

  const props = {
    showUploadList: false,
    name: "avatar",
    headers: {
      authorization: "authorization-text",
    },
    accept: "image/png, image/jpeg, image/jpg",
    maxCount: 1,
    // listType: "picture",
    beforeUpload: () => false,
    // fileList: imageData.fileList,
    onChange: async ({ fileList }) => {
      setIsFileUploading(true);
      setImageData((prev) => ({
        ...prev,
        profile: {
          ...prev.profile,
          fileList,
          preview: URL.createObjectURL(fileList[0]?.originFileObj),
        },
      }));
      const fileName = await uploadDocFun(fileList);
      setUserData((prev) => ({
        ...prev,
        Documents: {
          ...prev.Documents,
          ProfilePicture: fileName,
        },
      }));
      setIsFileUploading(false);
    },
  };

  const handleSave = async (values) => {
    // console.log(values, " = valuesssss:BasicInformationStep");
    setLoading(true);
    const dataToBeSend = {
      ...userData,
      IsNewCvUpload: userData?.Resume?.length ? true : false,
      DOB: userData?.DOB ? dayjs(userData?.DOB).format(format) : null,
      IsWorking: userData.Working?.includes("working"),
      IsStudent: userData.Working?.includes("studying"),
    };

    delete dataToBeSend.Working;
    console.log(dataToBeSend, " = userData:BasicInformationStep");
    updateUserFormsDetails(dataToBeSend)
      .then((res) => {
        console.log(res, " = res:updateBasicInfo");
        dispatch(getUserAllFormsDetails()).unwrap();
        setLoading(false);
        toastMessage(
          // res.data?.message || "Your Basic Information Updated",
          "Your Basic Information Updated",
          "success"
        );
      })
      .catch((error) => {
        console.log(error, " = error:updateBasicInfo");
        toastMessage("Something went wrong", "error");
        setLoading(false);
      });
  };

  const handleChangeInput = async (value, name) => {
    console.log(value, " = value, ", name, " = nameeeeeeeeee");
    if (name.includes("Passport")) {
      setIsFileUploading(true);
      const passportRes = await uploadDocFun(value);
      setImageData((prev) => ({
        ...prev,
        passport: passportRes,
      }));
      setUserData((prev) => ({
        ...prev,
        Documents: {
          ...prev.Documents,
          Passports: passportRes,
        },
      }));
      setIsFileUploading(false);
    }
    if (name.includes("Resume")) {
      setIsFileUploading(true);
      const resumeRes = await uploadDocFun(value);
      setImageData((prev) => ({
        ...prev,
        resume: resumeRes,
      }));
      setUserData((prev) => ({
        ...prev,
        Documents: {
          ...prev.Documents,
          Resume: resumeRes,
        },
      }));
      setIsFileUploading(false);
    }
    if (name.includes("LettersOfRecommendations")) {
      setIsFileUploading(true);
      const letterRes = await uploadDocFun(value);
      setImageData((prev) => ({
        ...prev,
        lettersOfRecommendations: letterRes,
      }));
      setUserData((prev) => ({
        ...prev,
        Documents: {
          ...prev.Documents,
          LettersOfRecommendations: letterRes,
        },
      }));
      setIsFileUploading(false);
    }
    if (name.includes("Country")) {
      console.log(
        name.includes("Country"),
        " =name.includes('Country'), ",
        name,
        " = name, ",
        value,
        " = valueeeeeee"
      );
      setUserData((prev) => ({ ...prev, [name]: value, City: null }));
      form.setFieldsValue({ [name]: value, City: "" });
    } else {
      setUserData((prev) => ({ ...prev, [name]: value }));
      form.setFieldsValue({ [name]: value });
    }
  };

  console.log(userData, "userDatauserData:PersonalInformationStep");
  // const NameChar = profile?.Name.charAt(0);

  return (
    <div>
      {/* {loading && <LoadingModal className="bg-gray-500/80" />} */}
      <p className="text-[18px] font-semibold mt-4 mb-2">General Information</p>
      <div className="flex gap-x-10">
        <div className="relative flex justify-center items-center  rounded-2xl">
          {dpLoading ? (
            <LoadingCom />
          ) : (
            imageData?.profile?.preview && (
              <Avatar
                size={100}
                src={imageData?.profile?.preview}
                icon={<UserOutlined />}
              />
            )
          )}
        </div>
        <div className="">
          <div className="flex gap-x-6 sm:w-[100px] sm:flex-col">
            <Upload {...props} className="sm:w-[200px]">
              <GradientButton>
                {/* <span>{CloudIcon}</span> */}
                <span className="ml-3 text-base font-medium">Upload Photo</span>
              </GradientButton>
            </Upload>
            {/* <button
              className="rounded-full px-8 border-[3px] border-darkOrange hover:border-darkerOrange"
              onClick={() => setImageData({})}
            >
              <span className="text-orange-gradient">Reset</span>
            </button> */}
          </div>
          <p className="text-gray-400 text-[14px] font-normal mt-3">
            Allowed JPG, GIF or PNG. Max size of 800K
          </p>
        </div>
      </div>
      <Form
        labelCol={1}
        onFinish={handleSave}
        form={form}
        // initialValues={{
        //   Email: userAttributes?.email,
        //   Phone: userAttributes?.phone_number,
        // }}
        className="w-full mt-8 flex flex-wrap justify-between items-center gap-x-8 gap-y-5"
      >
        {formGenerationInfo?.map((data, i) => {
          // if (data.type === "Checkbox" && data.name === "Working") {
          // }
          return (
            <FormItem
              key={i}
              className={`w-full px-5 sm:px-0 sm:w-full ${
                data.type === "Checkbox"
                  ? "lg:w-full justify-center"
                  : "lg:w-[47%]"
              } ${data.className}`}
              name={data.name}
              rules={data.rules}
              // dependencies={data?.dependencies}
            >
              <p className="text-gray-500">{data.label}</p>
              <CurrentInput
                data={data}
                onChange={handleChangeInput}
                formInputData={userData}
                isDisabled={data.name === "Email"} //  || data.name === "Phone"    // add this if disabled phone
              />
            </FormItem>
          );
        })}
        <div className="w-full flex justify-center">
          <Tooltip
            title={
              btnDisableCond
                ? "Once you click on the 'Final Submission' button, you won't be able to change your details."
                : ""
            }
          >
            <button
              type="submit"
              disabled={isFileUploading || btnDisableCond}
              className="flex items-center rounded-full px-16 py-[4px] border-[3px] border-darkOrange hover:border-darkerOrange"
            >
              <span className="text-orange-gradient">Save Updates</span>
              {isFileUploading && (
                <LoadingOutlined
                  style={{ color: "orange", fontSize: "18px", marginLeft: 10 }}
                />
              )}
            </button>
          </Tooltip>
        </div>
        {/* <div className="w-full flex justify-end">
          <p className="text-darkerOrange text-lg font-semibold cursor-pointer hover:text-darkOrange">
            Delete my account
          </p>
        </div> */}
      </Form>
    </div>
  );
};

export default BasicInformationStep;
